export default __webpack_public_path__ + "3e4991429fda59ffd72f8924002ef559.ttf";